import { CardContent, Card, Typography, Box, Button } from "@material-ui/core";
import React, { FC } from "react";
import Loading from "./components/Loading";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import ButtonLink from "../ButtonLink";
import { Fade } from "@mui/material";

const useStyle = makeStyles({
  card: {
    borderRadius: '14px'
  },
  content: {
    position: 'relative',
    padding: '13px !important',
  },
  title: {
    marginBottom: '12.11px'
  },
  count: {
    marginBottom: '13px'
  },
})

type PropTypes = {
  count: number | null,
  selectedCompanyId: string
}

const NumberOfPhotosUploaded:FC<PropTypes> = ({count,selectedCompanyId}) => {
  const classes = useStyle()
  const { t } = useTranslation();

  return (
    <Fade in={true}>
      <Card className={classes.card}>
        <CardContent className={classes.content}>
          <Typography className={classes.title}>
            {t("statsPage_numberOfPhotosUploaded")}
          </Typography>
          <Loading loading={!count && count !== 0} height={56}>
            <Box>
              <Typography className={classes.count} variant="h4">
                {count ? count : 0}
              </Typography>
              <ButtonLink
                to={`/stats/images/${selectedCompanyId}`}
                text={t('statsPage_See_photos')}
              />
            </Box>
          </Loading>
        </CardContent>
      </Card>
    </Fade>
  )
}
export default NumberOfPhotosUploaded
